import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import messages from 'src/pages/TutorialDetailsPage/messages';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

type DeleteTutorialQuestionProps = {
  tutorialUuid: string;
  questionUuid: string;
};

const deleteTutorialQuestion = async ({
  tutorialUuid,
  questionUuid,
}: DeleteTutorialQuestionProps) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteTutorialQuestion(tutorialUuid, questionUuid),
  );
  return data;
};

export const useDeleteTutorialQuestion = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteTutorialQuestion,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialQuestionDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};
